export const GoogleCalendarMutations = {
  setGoogleCalendarInfo: (state, data) => { state.calendarInfo = data },
  updateGoogleCalendarInfo: (state, data) => { state.calendarInfo = { ...state.calendarInfo, ...data } },
}
